module.exports = __webpack_public_path__ + "static/media/Element_11_treatments.eae7621e.svg";